export const SITE = {
  name: "FIX ROMA H24",
  domain: "https://fixromah24.com",
  payoff: "Pronto intervento H24 a Roma",
  phoneDisplay: "06 8590 2421",
  phoneRaw: "+390685902421",
  email: "fixromah24@libero.it",
  coverage: "Roma e provincia",
};

export const TEL_HREF = `tel:${SITE.phoneRaw}`;
export const MAIL_HREF = `mailto:${SITE.email}`;

export const trackEvent = (event, params = {}) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") {
    window.gtag("event", event, params);
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

export const trackCall = (location) => {
  trackEvent("click_to_call", { cta_location: location });
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "conversion", {
      send_to: "AW-18284576687/C7LKCP2f9qcdEK__4Y5E",
    });
  }
};
